import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import Draggable from 'react-draggable';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../../components/common';
import { useCastedParams } from '../../lib/hooks';
import { getTeam, getTeamReps, selectTeam, selectTeamReps } from '../../redux';
import { TeamMap, TeamMapProvider } from './TeamMap';
import '../../assets/scss/leaflet.scss';
import { TeamReps } from './TeamReps';
const TeamDetails = () => {
    const dispatch = useDispatch();
    const { teamId } = useCastedParams(Number);
    const teamRepRef = useRef(null);
    const draggedRef = useRef(false);
    const [repIds, setRepIds] = useState([]);
    const { team, isLoading } = useSelector(selectTeam);
    const { teamReps, isLoading: isTeamRepsLoading } = useSelector(selectTeamReps);
    useEffect(() => {
        dispatch(getTeam.request({ teamId }));
    }, [
        dispatch,
        teamId,
    ]);
    useEffect(() => {
        dispatch(getTeamReps.request({ teamId }));
    }, [
        dispatch,
        teamId,
    ]);
    const onRepClick = (selectedRepId) => {
        const currentlySelectedReps = [...repIds];
        if (currentlySelectedReps.includes(selectedRepId)) {
            currentlySelectedReps.splice(currentlySelectedReps.indexOf(selectedRepId), 1);
        }
        else {
            currentlySelectedReps.push(selectedRepId);
        }
        setRepIds(currentlySelectedReps);
    };
    const onGlobalRepClick = () => {
        let currentlySelectedReps = [...repIds];
        if (currentlySelectedReps.length === 0) {
            currentlySelectedReps = teamReps.map(({ id }) => id);
        }
        else {
            currentlySelectedReps = [];
        }
        setRepIds(currentlySelectedReps);
    };
    return (_jsxs("div", { className: "flow-root relative", children: [_jsx(Draggable, { nodeRef: teamRepRef, onDrag: () => { draggedRef.current = true; }, defaultPosition: { x: 10, y: 10 }, children: _jsx("div", { ref: teamRepRef, className: "overflow-visible rounded-lg touch-pan-auto top-0 absolute z-[1100] inline-block align-bottom bg-white text-left shadow-xl", children: _jsx(TeamReps, { repList: teamReps, selectedReps: repIds, loading: isTeamRepsLoading, onRepClick: onRepClick, onGlobalRepClick: onGlobalRepClick, draggedRef: draggedRef }) }) }), isLoading ? (_jsx(Loader, { className: "w-full h-[800px] items-center" })) : (_jsx(TeamMapProvider, { children: _jsx(TeamMap, { teamId: teamId, boundary: team?.boundaries, center: team?.center, repIds: repIds, repOptions: teamReps }) }))] }));
};
export default TeamDetails;
